/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type DatasetStatus = "ACTIVE" | "ARCHIVED";
export const DatasetStatus = {
  Active: "ACTIVE",
  Archived: "ARCHIVED",
} as const;
